var _rect, _ellipse, _circle, _ellipse2, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 250,
    viewBox: "0 0 299 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 200.778,
    y: 99.9173,
    width: 82.7629,
    height: 123.947,
    rx: 41.3815,
    stroke: "#DEE0FE",
    strokeOpacity: 0.6,
    strokeWidth: 29.3208
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.7848,
    cy: 34.0943,
    rx: 32.672,
    ry: 33.1388,
    fill: "#DEE0FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.598,
    cy: 39.327,
    r: 27.494,
    fill: "#DEE0FE",
    fillOpacity: 0.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.98,
    cy: 45.6086,
    rx: 23.3372,
    ry: 23.8039,
    fill: "#DEE0FE",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.426,
    y: 95.6223,
    width: 88.499,
    height: 132.538,
    rx: 44.2495,
    stroke: "#DEE0FE",
    strokeOpacity: 0.8,
    strokeWidth: 31.353
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0348,
    y: 91.1202,
    width: 94.5104,
    height: 141.54,
    rx: 47.2552,
    stroke: "#DEE0FE",
    strokeWidth: 33.4827
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.70836a139028df5227ba284e2d65c30c.svg";
export { ForwardRef as ReactComponent };